// tslint:disable:file-name-casing file-header
// GENERATED CODE: DO NOT EDIT
import { useAsObservable } from "./AsObservable";
import { useAsync } from "./Async";
import { useAsyncLegacy } from "./AsyncLegacy";
import { useAsyncReducer } from "./AsyncReducer";
import { ContextDispatcher, } from "./ContextDispatcher";
import * as DONOTUSEInternalLocalisation from "./DONOTUSEInternalLocalisation";
import * as DONOTUSEInternalTheme from "./DONOTUSEInternalTheme";
import { useForwardedRef } from "./ForwardedRef";
import { useFunctionAsObservable } from "./FunctionAsObservable";
import { useIsMounted } from "./IsMounted";
import * as Localisation from "./Localisation";
import { useMemoAsObservable } from "./MemoAsObservable";
import { useObservable } from "./Observable";
import { Optional, } from "./Optional";
import { useRxOperator } from "./RxOperator";
import { useSingletonClass } from "./SingletonClass";
import { StateReducer, } from "./StateReducer";
import * as StyleSheet from "./StyleSheet";
import * as Theme from "./Theme";
import { WithContext } from "./WithContext";
export const l_ = Localisation.l_;
export const useLocalisation = Localisation.useLocalisation;
export const useTemplate = Theme.useTemplate;
export { ContextDispatcher, DONOTUSEInternalLocalisation, DONOTUSEInternalTheme, Localisation, Optional, StateReducer, StyleSheet, Theme, useAsObservable, useAsync, useAsyncLegacy, useAsyncReducer, useForwardedRef, useFunctionAsObservable, useIsMounted, useMemoAsObservable, useObservable, useRxOperator, useSingletonClass, WithContext, };
